import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=93fe807e&scoped=true&"
import script from "./newHome.vue?vue&type=script&lang=js&"
export * from "./newHome.vue?vue&type=script&lang=js&"
import style0 from "./newHome.vue?vue&type=style&index=0&id=93fe807e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fe807e",
  null
  
)

export default component.exports